
<img *ngIf="searchType==vehicleSearchTypeEnum.classSearch" class="img-fluid"
  [lazyLoad]="getVehicleImageClass(vehicle)"
  [alt]="vehicle.vehicleName" (click)="onVehicleImageClicked(vehicle)" >
<!--[src]="getVehicleImageClass(vehicle)" -->

<img *ngIf="searchType==vehicleSearchTypeEnum.vehicleSearch" [debug]="true" class="img-fluid"
  [lazyLoad]="getVehicleImageVehicle(vehicle)" [alt]="vehicle.vehicleName" (click)="onVehicleImageClicked(vehicle)"
 >

<img *ngIf="searchType==vehicleSearchTypeEnum.MakeModelYearSearch"  class="img-fluid"
  [lazyLoad]="getVehicleImageMMY(vehicle)" [alt]="vehicle.vehicleName" (click)="onVehicleImageClicked(vehicle)"
 >
